<template>
    <div class="page formPage" id="mapManagement">
        <el-row :gutter="12">
            <el-col :span="4">
                <el-input placeholder="请输入地图名称" clearable size="small" v-model="culturalName"></el-input>
            </el-col>
            <el-col :span="2">
                <el-button size="small" icon="el-icon-search" type="primary" @click="getList(1)">查询</el-button>
            </el-col>
            <el-col :span="2">
                <el-button size="small" icon="el-icon-refresh-left" @click="reset()">重置</el-button>
            </el-col>
            <el-col :span="16" style="text-align: right">
                <el-button v-if="hasPermission('map:mapManagement:add')" size="small" type="primary"
                           @click="details(0,2)">新增
                </el-button>
                <el-button v-if="hasPermission('map:mapManagement:delete')" size="small"
                           :disabled="multipleSelection.length == 0" type="primary" @click="Wudelete()">删除
                </el-button>
            </el-col>
        </el-row>
        <el-table
                :data="dataList"
                v-loading="loading"
                ref="tableRadg"
                size="small"
                height="calc(100% - 90px)"
                @selection-change="handleSelectionChange"
                    class="table">
            <el-table-column type="selection" width="50" fixed></el-table-column>
            <el-table-column prop="imgUrl" label="地图" width="150">
                <template slot-scope="scope">
                    <el-image
                            style="width: 100px;height: 100px;"
                            :src="scope.row.guidedExhibitionFiles[0].imgUrl"
                            :fit="'contain'"></el-image>
                </template>
            </el-table-column>
            <el-table-column prop="enabledState" label="启用状态" show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-switch
                            v-model="scope.row.enabledState"
                            active-value="1"
                            inactive-value="0"
                            @change="stateChange(scope.row)"
                    >
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="introduction" label="简介" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="createUserName" label="添加人" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="createTime" label="添加时间" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ scope.row.createTime | formatDate }}
                </template>
            </el-table-column>
            <el-table-column prop="updateTime" label="最后修改时间" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ scope.row.updateTime | formatDate }}
                </template>
            </el-table-column>
            <el-table-column fixed="right" width="200" label="操作">
                <template slot-scope="scope">
                    <el-button
                            v-if="hasPermission('map:mapManagement:see')"
                            icon="el-icon-view" type="text"
                            size="mini" @click="details(scope.row.id,0)">详情
                    </el-button>
                    <el-button
                            v-if="hasPermission('map:mapManagement:edit')"
                            icon="el-icon-edit" type="text"
                            size="mini" @click="details(scope.row.id,1)">编辑
                    </el-button>
                    <el-button
                            v-if="hasPermission('map:mapManagement:delete') && scope.row.enabledState == 0"
                            icon="el-icon-delete" type="text"
                            size="mini" @click="Wudelete(scope.row.id)">删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                :current-page="pageNo"
                :page-size="pageSize"
                :page-sizes="[10, 20, 50, 100]"
                :total="total"
                ref="table"
                @size-change="sizeChangeHandle"
                @current-change="currentChangeHandle"
                background
                layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
        <!--详情编辑弹窗-->
        <el-dialog
                :title="distinguish == 0 ? '地图导览详情': distinguish == 1 ? '地图导览编辑' : '地图导览新增'"
                :visible.sync="dialogVisible"
                width="600px"
                :close-on-click-modal="false"
                :before-close="handleClose">
            <el-form :model="ruleForm" :rules="rules" size="small" ref="ruleForm" label-width="100px"
                     class="demo-ruleForm">
                <div v-if="distinguish != 0">
                    <el-form-item label="名称" prop="name">
                        <el-input maxlength="20" placeholder="请输入地图名称（限20字）" :disabled="!distinguish"
                                  v-model.trim="ruleForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="简介" prop="introduction">
                        <el-input type="textarea"
                                  maxlength="100"
                                  :rows="4" placeholder="请输入简介(限100字)" :disabled="!distinguish"
                                  v-model="ruleForm.introduction"></el-input>
                    </el-form-item>
                    <el-form-item label="地图" prop="guidedExhibitionFiles">
                        <el-button type="primary" :disabled="ruleForm.guidedExhibitionFiles.length == 1 || !distinguish"
                                   size="small"
                                   @click="upDate(1)">上传图片
                        </el-button>
                        <div class="flex_l_c">
                            <div class="zhanshi" v-for="item in ruleForm.guidedExhibitionFiles" :key="item.name">
                                <el-image
                                        style="width: 200px;"
                                        :src="item.imgUrl"
                                        :fit="'contain'">
                                    <div slot="placeholder" class="image-slot">
                                        加载中<span class="dot">...</span>
                                    </div>
                                </el-image>
                                <div v-if="distinguish" @click="deletesshuj(item,2)" class="el-icon-error sheZhi"></div>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item prop="enabledState" label="状态">
                        <el-switch
                                :disabled="!distinguish"
                                v-model="ruleForm.enabledState"
                                active-value="1"
                                inactive-value="0"
                        >
                        </el-switch>
                    </el-form-item>
                    <el-form-item v-if="!distinguish" label="添加人" prop="createUserName">
                        <el-input :disabled="!distinguish" v-model="ruleForm.createUserName"></el-input>
                    </el-form-item>
                    <el-form-item v-if="!distinguish" label="添加时间" prop="createTime">
                        <el-date-picker
                                style="width: 100%"
                                :disabled="!distinguish"
                                v-model="ruleForm.createTime"
                                type="datetime"
                                placeholder="选择日期时间">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item v-if="!distinguish" label="最后修改时间" prop="updateTime">
                        <el-date-picker
                                style="width: 100%"
                                :disabled="!distinguish"
                                v-model="ruleForm.updateTime"
                                type="datetime"
                                placeholder="">
                        </el-date-picker>
                    </el-form-item>
                </div>
                <div v-else>
                    <el-form-item label="名称" prop="name">
                        <div>{{ ruleForm.name }}</div>
                    </el-form-item>
                    <el-form-item label="简介" prop="introduction">
                        <div>{{ ruleForm.introduction }}</div>
                    </el-form-item>
                    <el-form-item label="地图" prop="guidedExhibitionFiles">
                        <div class="flex_l_c">
                            <div class="zhanshi" v-for="item in ruleForm.guidedExhibitionFiles" :key="item.name">
                                <el-image
                                        style="width: 200px;"
                                        :src="item.imgUrl"
                                        :fit="'contain'">
                                    <div slot="placeholder" class="image-slot">
                                        加载中<span class="dot">...</span>
                                    </div>
                                </el-image>
                                <div v-if="distinguish" @click="deletesshuj(item,2)" class="el-icon-error sheZhi"></div>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item prop="enabledState" label="状态">
                        <el-switch
                                :disabled="!distinguish"
                                v-model="ruleForm.enabledState"
                                active-value="1"
                                inactive-value="0"
                        >
                        </el-switch>
                    </el-form-item>
                    <el-form-item v-if="!distinguish" label="添加人" prop="createUserName">
                        <div>{{ ruleForm.createUserName }}</div>
                    </el-form-item>
                    <el-form-item v-if="!distinguish" label="添加时间" prop="createTime">
                        <div>{{ ruleForm.createTime | formatDate }}</div>
                    </el-form-item>
                    <el-form-item v-if="!distinguish" label="最后修改时间" pro    p="updateTime">
                        <div>{{ ruleForm.updateTime | formatDate }}</div>
                    </el-form-item>
                </div>
                <div style="width: 100%; height: 20px"></div>
                <!--                <el-form-item v-if="!distinguish" label="修改用户" prop="updateUser">-->
                <!--                    <el-input :disabled="!distinguish" v-model="ruleForm.updateName"></el-input>-->
                <!--                </el-form-item>-->
                <div style="text-align: center;width: 560px;position: absolute; padding-top: 10px;background: #ffffff; bottom: 10px">
                    <el-button :loading="submitLoading" size="small" v-if="distinguish == 1" type="primary"
                               @click="submitForm('ruleForm',0)">
                        保存
                    </el-button>
                    <el-button :loading="submitLoading" size="small" v-if="distinguish == 2" type="primary"
                               @click="submitForm('ruleForm',1)">
                        新增
                    </el-button>
                    <el-button size="small" v-if="distinguish" @click="handleClose()">取消</el-button>
                </div>
            </el-form>
        </el-dialog>
        <uploadPopup ref="uploadpopup" :fileList="ruleForm.img" :allowFileNumber="allowFileNumber"
                     :allowFileSize="allowFileSize" :allowFiles="allowFiles" @updatalist=receiveList></uploadPopup>
    </div>
</template>

<script>
    import uploadPopup from '../exhibition/uploadPopup'

    export default {
        name: "mapManagement",
        components: {uploadPopup},
        data() {
            return {
                culturalName: '',//文物名称
                dataList: [],
                loading: false,
                pageNo: 1,
                pageSize: 10,
                total: 0,
                distinguish: 0,
                dialogVisible: false,
                submitLoading: false,
                ruleForm: {
                    name: '',
                    introduction: '',
                    guidedExhibitionFiles: [],
                    enabledState: '0',
                    createUserName: '',
                    createTime: '',
                    updateTime: '',
                },
                allowFileNumber: 1,
                allowFileSize: 0,
                allowFiles: ['png', 'bmp', 'jpg', 'jpeg', 'gif'],
                multipleSelection: [],
                rules: {
                    guidedExhibitionFiles: [
                        {required: true, message: '请上传地图', trigger: 'blur'},
                    ],
                    name: [
                        {required: true, message: '请填写名称', trigger: 'blur'},
                    ],
                },
                uploadRequire: {
                    //上传图片要求
                    showTips: false,
                    imgCount: 1, // 上传数量 0表示不限制数量
                    imgList: [], // 已上传的文件
                    uploadPath: "course"
                },
            }
        },
        mounted() {
            this.getList();
            window.addEventListener('resize', this.windowSize());
        },
        methods: {
            windowSize() {
                let that = this
                that.$nextTick(() => {
                    that.$refs.table.doLayout();
                });
            },

            //获取列表
            getList(num) {
                let that = this
                this.loading = true;
                if (num) {
                    this.pageNo = 1
                }
                this.$axios(this.api.minAppMap.queryAllByLimit, {
                    name: this.culturalName,
                    current: this.pageNo,
                    size: this.pageSize,
                    flag:2,
                }, 'post').then(res => {
                    this.loading = false;
                    this.dataList = res.data.records;
                    this.total = parseInt(res.data.total)
                })
            },

            //上传 num1为banner上传 2图片上传,//3全景图片
            upDate(num) {
                this.upDateNumber = num
                this.$refs.uploadpopup.uploadPath = 'guided';
                this.allowFiles = ['png', 'bmp', 'jpg', 'jpeg', 'gif'];
                this.fileList = this.ruleForm.guidedExhibitionFiles;
                this.allowFileSize = 0;
                this.allowFileNumber = 1;
                this.$refs.uploadpopup.numb = 1;
                this.$refs.uploadpopup.dialogVisible = true;
                this.$refs.uploadpopup.uploading = true;
            },

            //接受上传数据
            receiveList(arry) {
                arry[0].forEach(item => {
                    item.fileType = 1
                    item.type = 3
                })
                this.ruleForm.guidedExhibitionFiles = arry[0];
            },

            //删除
            deletesshuj(row, num) {
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    if (row.id) {
                        //删除以前上传的图片
                        this.$axios(this.api.threeDFileControl.fileRemoveById + row.id, {}, 'delete').then(res => {
                            console.log(res)
                        })
                    }
                    this.ruleForm.guidedExhibitionFiles = [];
                })
            },

            //多选
            handleSelectionChange(val) {
                this.multipleSelection = [];
                val.forEach(item => {
                    if (item.enabledState == 0) {
                        this.multipleSelection.push(item.id)
                    }
                })
            },

            //重置
            reset() {
                this.culturalName = '';
                this.getList()
            },

            //num 0详情, 1编辑,2新增
            details(id, num) {
                if (id) {
                    //获取文件详情
                    this.$axios(this.api.minAppMap.getById + id, {}, 'get').then(res => {
                        console.log(res)
                        this.ruleForm = res.data;
                    })
                }
                this.distinguish = num;
                this.dialogVisible = true;
            },

            //修改状态
            stateChange(obj) {
                this.$axios(this.api.minAppMap.updateById, {
                    ...obj
                }, 'put').then(res => {
                    if (res.status) {
                        this.$message.success('修改成功');
                    } else {
                        this.$message.error(res.msg);
                    }
                    this.getList();
                })
            },

            //删除
            Wudelete(id) {
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let ids = []
                    if (id) {
                        ids = [id]
                    } else {
                        ids = this.multipleSelection
                    }
                    this.$axios(this.api.minAppMap.removeById, ids, 'post').then(res => {
                        console.log(res)
                        if (res.status) {
                            this.$message.success('删除成功');
                            if (this.dataList.length == ids.length && this.pageNo > 1) this.pageNo--;
                            this.getList();
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                }).catch(() => {
                });
            },

            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageNo = 1;
                this.getList();
            },

            // 当前页
            currentChangeHandle(val) {
                this.pageNo = val;
                this.getList();
            },

            //关闭弹窗
            handleClose() {
                this.$refs['ruleForm'].resetFields();
                this.dialogVisible = false;
                this.ruleForm = {
                    name: '',
                    introduction: '',
                    guidedExhibitionFiles: [],
                    enabledState: 0,

                    createUser: '',
                    createTime: '',
                    updateTime: '',
                };
            },

            //num 0保存，1新增
            submitForm(formName, num) {
                if (this.ruleForm.name.trim() == '') {
                    this.$message.error('请输入地图名称')
                    return
                }
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.submitLoading = true
                        if (num == 0) { //保存
                            this.$axios(this.api.minAppMap.updateById, {...this.ruleForm}, 'put').then(res => {
                                if (res.status) {
                                    this.$message.success('保存成功')
                                    this.handleClose()
                                    this.getList();
                                } else {
                                    this.$message.error(res.msg);
                                }
                                this.submitLoading = false
                            })
                        } else { //新增
                            this.$axios(this.api.minAppMap.save, {...this.ruleForm}, 'post').then(res => {
                                console.log(res);
                                if (res.status) {
                                    this.$message.success('新增成功')
                                    this.handleClose()
                                    this.getList();
                                } else {
                                    this.$message.error(res.msg);
                                }
                                this.submitLoading = false
                            })
                        }
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        }
    }
</script>

<style scoped>
    .zhanshi {
        position: relative;
        margin-top: 10px;
    }

    .sheZhi {
        position: absolute;
        font-size: 18px;
        color: #7F7F7F;
        transform: translateX(-50%) translateY(-50%);
        cursor: pointer;
    }

    .demo-ruleForm{
        height: 60vh;
        overflow-y: auto;
    }
</style>
